module.exports = "<div class=\"suggestion-container\">\n  <!-- <input type=\"text\" autocomplete=\"off\" placeholder=\"Product\" class=\"k-input\"> -->\n  <input type=\"text\" autocomplete=\"off\" placeholder={{search_label}} class=\"form-control k-input\" *ngIf=\"flag\" type=\"text\" [(ngModel)]=\"ClientName\" \n  (keyup.enter)=\"searchClient(ClientName)\"/>\n  <input class=\"form-control\" [(ngModel)]=\"ClientName\" disabled *ngIf=\"!flag\" type=\"text\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/search-products/search-products.component.html
// module id = ./src/app/search-products/search-products.component.html
// module chunks = main